/**
 * BLOCK: navbar
 */

import DynamicDesktopToOverlaySwitcher from "./scripts-DynamicDesktopToOverlaySwitcher.jsx";
import NavOverlay from "./scripts-NavOverlay.jsx";
import NavDesktop from "./scripts-NavDesktop.jsx";
import FormateDropdown from "./scripts-FormateDropdown.jsx";

jQuery(document).ready(function ($) {
  window.$ = $;

  class LutherNavbar {
    constructor() {
      this.navbar = document.querySelector(".page-navbar");

      this.Overlay = new NavOverlay(this.navbar);

      this.Desktop = new NavDesktop(this.navbar);

      this.DynamicDesktopToOverlaySwitcher =
        new DynamicDesktopToOverlaySwitcher(this.navbar);

      this.FormateDropdown = new FormateDropdown(this.navbar);

      // this.navbar.classList.add("page-navbar--loaded"); // wait for DynamicDesktopToOverlaySwitcher to finish
    }
  }

  window.luther = window.luther || {};
  window.luther.navbar = new LutherNavbar();
});
